import { isMobile } from '../helpers/isMobile';

// RU: id строки — индекс в InitialState.oddsInfo сервера: коэффициенты пейтейбла ядро берёт
//     с сервера (решение владельца 05.10) и нормализует строку (без нулей, по убыванию); у сервера
//     под индексом 8 пустая строка — id 8 → 9, 9 → 10.
export const oddsInfoEnumsByGame = {
  121: {
    oddsInfoEnumWeb: [
      { id: 0, oddX: -35, oddContainerY: 25, oddsContainerX: 230, oddsContainerY: 590 },
      { id: 1, oddX: -35, oddContainerY: 25, oddsContainerX: 467, oddsContainerY: 590 },
      { id: 2, oddX: -35, oddContainerY: 25, oddsContainerX: 697, oddsContainerY: 590 },
      { id: 3, oddX: -35, oddContainerY: 25, oddsContainerX: 927, oddsContainerY: 590 },
      { id: 4, oddX: -35, oddContainerY: 25, oddsContainerX: 1157, oddsContainerY: 590 },
      { id: 9, oddX: -35, oddContainerY: 25, oddsContainerX: 1120, oddsContainerY: 230 },
      { id: 10, oddX: -35, oddContainerY: 25, oddsContainerX: 354, oddsContainerY: 230 },
    ],
    oddsInfoEnumMobile: [
      { id: 0, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 975 },
      { id: 1, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 975 },
      { id: 2, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 1235 },
      { id: 3, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 1235 },
      { id: 4, oddX: 12, oddContainerY: 15, oddsContainerX: 244, oddsContainerY: 1430 },
      { id: 9, oddX: 12, oddContainerY: 15, oddsContainerX: 374, oddsContainerY: 643 },
      { id: 10, oddX: 12, oddContainerY: 15, oddsContainerX: 114, oddsContainerY: 643 },
    ],
  },
};

export const payTableStepsContentByGame = {
  121: {
    step0: {
      id: 0,
      text: 'SYMBOL_PAYOUT',
      contentImage: 'payTableStep0Image',
      stepInfoText: [
        {
          x: isMobile() ? 100 : 588,
          y: isMobile() ? 335 : 300,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 340 : 280,
          text: 'SYMBOL_PAYOUT_1',
        },
        {
          x: isMobile() ? 325 : 975,
          y: isMobile() ? 705 : 330,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 160 : 280,
          text: 'SYMBOL_PAYOUT_3',
        },
        {
          x: isMobile() ? 70 : 205,
          y: isMobile() ? 705 : 330,
          type: 'middleText',
          align: 'center',
          wordWrapWidth: isMobile() ? 160 : 280,
          text: 'SYMBOL_PAYOUT_2',
        },
      ],
      y: 0,
      titleY: 45,
    },
    step1: {
      id: 1,
      text: 'WINNING_LINES',
      contentImage: 'payTableStep1Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 2160,
          y: isMobile() ? 2000 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WINNING_LINES_TEXT',
        },
      ],
      y: 1527,
    },
    step2: {
      id: 2,
      text: 'WILD',
      contentImage: 'payTableStep2Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 3600,
          y: isMobile() ? 2408 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'WILDS_TEXT',
        },
      ],
      y: isMobile() ? 2060 : 1469,
    },
    // RU: джекпот — слой платформы: страница скрыта флагом, а не удалена, чтобы не съехала
    //     нумерация шагов и ссылки на картинки шага (GAME-MIGRATION §6).
    step3: {
      isHide: true,
      id: 3,
      text: 'JACKPOT',
      contentImage: 'payTableStep3Image',
      stepInfoText: [
        {
          x: isMobile() ? 270 : 5040,
          y: isMobile() ? 2880 : 675,
          anchor: 0.5,
          type: 'text',
          align: 'center',
          wordWrapWidth: isMobile() ? 394 : 687,
          text: 'JACKPOT_INTRO',
        },
      ],
      y: isMobile() ? 2480 : 2024,
    },
  },
};
